import moment from 'moment-timezone';

import {
  ACTIVE_ADVISORY,
  ACTIVE_PLUS,
  ALASKA_529,
  BROKERAGE,
  isHighNetWorth,
  isMillionPlus,
  isPreferred,
  MARYLAND_529,
  NATIONAL_529
} from './constants';

const LINK_REGEX = /<link>(.*?)<\/link>/g;

const SPLIT_REGEX = /([^:]*):*(.*)?/;
const NEW_LINE_REGEX = /(\\r)*(\\n)+/g;
const BR_REPLACE_REGEX = /<Br>/g;
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const displayShortDate = (utcDate, includeTime = false,keepLocalTime =false) => {
  const formattedDate = moment(utcDate).tz('America/New_York').format('MM-DD-YYYY');
  const formattedDateWithSeconds = moment(utcDate).utc(keepLocalTime).format('MM-DD-YYYY hh:mm:ss a')
                                 .concat(" ET");
  return `${includeTime ? formattedDateWithSeconds : formattedDate}`;
};
export const displayInboxShortDate = (utcDate) => {
  const formattedDateWithSeconds = moment(utcDate).utc(true).format('MM-DD-YYYY hh:mm:ss a')
      .concat(" ET");
  return `${formattedDateWithSeconds}`;
};

export const displayHourMinuteSecond = utcDate =>
  moment(utcDate).tz('America/New_York').format('hh:mm:ss a z');

/**
 * Create a string  in the format of 'FullMonth, Date, FUllYear'
 * @param {string} utcDate
 * @returns {string}
 */
export const displayLongDate = utcDate => {
  const date = new Date(utcDate);

  return `${
    monthNames[date.getMonth()]
  } ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
};

export const getCurrentYear = () => new Date().getFullYear();

export const withoutTrailingSlash = value => {
  return value && value.endsWith('/')
    ? value.substring(0, value.length - 1)
    : value;
};

const replaceNewlines = messageText =>
  messageText.replace(NEW_LINE_REGEX, '<br>').replace(BR_REPLACE_REGEX, '<br>');

const extractUrls = (messageText, messageId) => {
  let result;
  let replaceArray = [];
  while ((result = LINK_REGEX.exec(messageText)) !== null) {
    let linkElementText, linkElementUrl;
    const [linkElement, linkElementContent] = result;
    const [, text, url] = linkElementContent.match(SPLIT_REGEX);

    if (text !== '') {
      linkElementText = text.trim();
    }

    if (url !== '') {
      const transformedUrl = withoutTrailingSlash(url.trim());
      linkElementUrl = messageId
        ? `${transformedUrl}?MessID=${messageId}`
        : transformedUrl;
    }

    replaceArray.push({
      linkElement,
      linkElementText,
      linkElementUrl
    });
  }

  return replaceArray;
};

export const transformMessageText = ({ content = '', messageId }) => {
  let formattedContent = replaceNewlines(content);
  const urlReplaceArray = extractUrls(formattedContent, messageId);
  urlReplaceArray.forEach(
    ({ linkElement, linkElementText, linkElementUrl }) => {
      const anchor =
        linkElementUrl && linkElementText
          ? `<a target="_blank"
            href="${linkElementUrl}">${linkElementText}</a>`
          : '';
      formattedContent = formattedContent.replace(linkElement, anchor);
    }
  );
  return trimUberRefNumber(formattedContent)
};

export const trimUberRefNumber = (content) => {
   const index = content.lastIndexOf('REF')
  return index >-1 ? content.slice(0, index) : content;
}

export const getMessageToID = (customerType, productTypes) => {
  const BROKERAGE_ID = '000DBI000';
  const FIVE29_ID = '000TRP000';
  const MARYLAND_529_ID = '000TRP000';
  //const APP_ID = '000APP000';
  const ULTRA_HIGH_NET_WORTH_ID = '000MIL000';
  const HIGH_NET_WORTH_ID = '000HNW000';
  const PREFERRED_ID = '000PFD000';
  const CORE_ID = '000TRP000';
  const isHighNetWorthType = isHighNetWorth(customerType);
  const isMillionPlusType = isMillionPlus(customerType);
  const isPreferredType = isPreferred(customerType);

  // // Check product types
  if (productTypes.includes(BROKERAGE) || productTypes.includes(ACTIVE_PLUS) || productTypes.includes(ACTIVE_ADVISORY)) {
    return BROKERAGE_ID;
  }
  if (productTypes.includes(MARYLAND_529)) {
    return MARYLAND_529_ID;
  }
  if (
    productTypes.includes(ALASKA_529) ||
    productTypes.includes(NATIONAL_529)
  ) {
    return FIVE29_ID;
  }
  //TODO: Revisit this in the future - DE37364 - INC1362824
  // if (productTypes.includes(ACTIVE_PLUS)) {
  //   return APP_ID;
  // }
  // Check Customer types if no product types apply
  if (isMillionPlusType) {
    return ULTRA_HIGH_NET_WORTH_ID;
  }
  if (isHighNetWorthType) {
    return HIGH_NET_WORTH_ID;
  }
  if (isPreferredType) {
    return PREFERRED_ID;
  }
  // Return Core if no other toIDs are applicable
  return CORE_ID;
};

export const getMessageToIdBySelectedAccountType = (selectedAccountType, accountTypes) => {
  const BROKERAGE_ID = '000DBI000';
  //const APP_ID = '000APP000';
  const CORE_ID = '000TRP000';

  // Convert selectedAccountType to a number if it is a string
  const selectedAccountTypeNumber = Number(selectedAccountType);

  // Check account type, or if ownership of brokerage
  if (accountTypes.includes(BROKERAGE) || selectedAccountTypeNumber === ACTIVE_PLUS || selectedAccountTypeNumber === ACTIVE_ADVISORY) {
    return BROKERAGE_ID;
  }
  // Return Core if no other toIDs are applicable
  return CORE_ID;
};

export const appendIdToBody = (message, customerType, productTypes) => {
  if (productTypes.includes(MARYLAND_529)) {
    return message + 'REF:000MD0000';
  } else {
    return message + `REF:${getMessageToID(customerType, productTypes)}`;
  }
};

export const appendIdToBodyBySelectedAccountType = (message, selectedAccountType, accountTypes) => {
  return message + `REF:${getMessageToIdBySelectedAccountType(selectedAccountType, accountTypes)}`;
};

export const replaceBreaksWithBr = message => {
  return message.split('\n').join('<br>');
};

export const dispatchPageLoad = pageName => {
  try {
    // instantiate a CustomEvent with an eventType of “pageLoad”
    const event = new CustomEvent('pageLoad', {
      detail: {
        page: pageName
      }
    });
    window.dispatchEvent(event);
  } catch (e) {
    //eslint-disable-no-empty
  }
};

export const ANALYTICS_MAP = {
  compose: 'Compose New Message',
  inbox: 'Inbox',
  reply: 'Reply',
  sent: 'Sent',
  view: 'View Message',
  view_sent: 'View Sent Message'
};
